import {createContext, useContext} from "react";
import {Spell} from "@/spells/model/Spell.ts";
import {Character} from "@/characters/model/Character.ts";

export type ModalContent =
    | {type: "SPELL"; id: string; spell: Spell}
    | {type: "CHARACTER"; id: string; character: Character};

export type ModalTarget =
    | {type: "SPELL"; id: string}
    | {type: "CHARACTER"; id: string};

export interface ModalReturn {
    content?: ModalContent;
    showSpell: (id: string) => void,
    showCharacter: (id: string) => void,
    hide: () => void,

    visibleToPlayer: boolean,
    setVisibleToPlayer: (visible: boolean) => void,
    loading: boolean,
    updatingVisibility: boolean,
    error?: string,
}

export const ModalContext = createContext<ModalReturn | null>(null)


export function useModal(): ModalReturn {
    const modal = useContext(ModalContext);
    if (!modal) {
        throw new Error("useModal must be used within a Provider")
    }
    return modal;
}
